export enum PromoUserTypeEnum {
  ALL = 'all',
  NEW = 'new',
}
